// 生产环境正式接口域名
export const API_ORIGIN =
  process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'

export const API_BASE =
  process.env.NODE_ENV === 'development' ? '/api' : 'https://d2h0m7gk9kbvfa.cloudfront.net/api'

export function resolveMediaUrl(url) {
  if (!url) return ''
  if (/^https?:\/\//i.test(url) || String(url).startsWith('data:')) return url
  if (String(url).startsWith('/')) return `${API_ORIGIN}${url}`
  return `${API_ORIGIN}/${url}`
}
